import Model from '../models/model';


const model = new Model({
	name: 'AccessLogDetail',
	readOnly: true,
	disableAdd: true,
	defaultSort: 'EventTime DESC',
	gridTitle: 'AccessLogDetail',
	showGridRefreshBtn: true,
	columns: [
		{ header: 'UniqueId', field: 'AccessLogDetailId', keyColumn: true, width: 250, hidden: true },
		{ field: 'EventTime', width: 180, type: 'dateTime', isLocal: true },
		{ field: 'Username', width: 140 },
		{ header: 'ScreenName', field: 'MenuName', width: 150 },
		{ header: 'IPAddress', field: 'IP', width: 130 },
		{ field: 'SessionId', width: 300 },
		{ field: 'FormParams', width: 1200, filterable: false }
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A2'
		}
	}
});

export default model.createFormBase();